/**
 * @lodex-pro/web-dispatch/auth/SignInPage — sign-in page.
 *
 * The shared sign-in screen (web-shared SignInScreen, 2026-10-21: "All sign in screens should be
 * the same"): email + password, MFA, "Forgot your password?" and the forced new password
 * (Quick 260827-fpc: every office user created or reset through TeamEditor lands in
 * FORCE_CHANGE_PASSWORD first).
 *
 * Navigation is a full-page `window.location.assign`; the props let tests stub it.
 *
 * Branding: lodeX Pro on hauler-facing surfaces (CLAUDE.md).
 */

import { SignInScreen } from '@lodex-pro/web-shared';
import type { FC } from 'react';

export interface SignInPageProps {
  readonly onSignedIn?: () => void;
  readonly onTotpSetupRequired?: () => void;
}

export const SignInPage: FC<SignInPageProps> = ({ onSignedIn, onTotpSetupRequired }) => (
  <SignInScreen
    appName="lodeX Pro Dispatch"
    onSignedIn={() => {
      if (onSignedIn !== undefined) {
        onSignedIn();
        return;
      }
      window.location.assign('/');
    }}
    onTotpSetupRequired={() => {
      if (onTotpSetupRequired !== undefined) {
        onTotpSetupRequired();
        return;
      }
      window.location.assign('/auth/totp-setup');
    }}
  />
);
